import { render, staticRenderFns } from "./CompactFileDisplay.vue?vue&type=template&id=47750e22&"
import script from "./CompactFileDisplay.vue?vue&type=script&lang=js&"
export * from "./CompactFileDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports